import { c as _c } from "react/compiler-runtime";
import { getRoleMenuItemSx, RoleMenuItem } from "@components/role/role-menu-item";
import { MenuItem, UserRoleIcon } from "@flat-ui";
/** "Change role" item of the 3-dot menu, with a sub-menu listing the roles to pick from */
export function ChangeRoleSubMenu(t0) {
  const $ = _c(11);
  const {
    roles,
    disabledRoles,
    selectedRole,
    onRoleClick
  } = t0;
  let t1;
  if ($[0] !== disabledRoles || $[1] !== onRoleClick || $[2] !== roles || $[3] !== selectedRole) {
    let t2;
    if ($[5] !== disabledRoles || $[6] !== onRoleClick || $[7] !== selectedRole) {
      t2 = role => <MenuItem key={role} value={role} disabled={disabledRoles.includes(role)} onClick={() => onRoleClick(role)} sx={getRoleMenuItemSx({
        isTableCell: false
      })}><RoleMenuItem role={role} isRoleSelected={role === selectedRole} /></MenuItem>;
      $[5] = disabledRoles;
      $[6] = onRoleClick;
      $[7] = selectedRole;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = roles.map(t2);
    $[0] = disabledRoles;
    $[1] = onRoleClick;
    $[2] = roles;
    $[3] = selectedRole;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <MenuItem label="Change role" Icon={UserRoleIcon} subMenuTrigger="click">{t1}</MenuItem>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}